/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as coreHttp from "@azure/core-http";
import * as Models from "../models";
import * as Mappers from "../models/sharedDevicesMappers";
import * as Parameters from "../models/parameters";
import { MicrosoftConsumerSecurityClientContext } from "../microsoftConsumerSecurityClientContext";

/** Class representing a SharedDevices. */
export class SharedDevices {
  private readonly client: MicrosoftConsumerSecurityClientContext;

  /**
   * Create a SharedDevices.
   * @param {MicrosoftConsumerSecurityClientContext} client Reference to the service client.
   */
  constructor(client: MicrosoftConsumerSecurityClientContext) {
    this.client = client;
  }

  /**
   * Calls Consumer Security Device Manager to update a specific device based on the information
   * @summary Updates a device for the user based on the information provided.
   * @param deviceId
   * @param [options] The optional parameters
   * @returns Promise<Models.SharedDevicesUpdateDeviceResponse>
   */
  updateDevice(deviceId: string, options?: Models.SharedDevicesUpdateDeviceOptionalParams): Promise<Models.SharedDevicesUpdateDeviceResponse>;
  /**
   * @param deviceId
   * @param callback The callback
   */
  updateDevice(deviceId: string, callback: coreHttp.ServiceCallback<Models.DeviceWideUpdate>): void;
  /**
   * @param deviceId
   * @param options The optional parameters
   * @param callback The callback
   */
  updateDevice(deviceId: string, options: Models.SharedDevicesUpdateDeviceOptionalParams, callback: coreHttp.ServiceCallback<Models.DeviceWideUpdate>): void;
  updateDevice(deviceId: string, options?: Models.SharedDevicesUpdateDeviceOptionalParams | coreHttp.ServiceCallback<Models.DeviceWideUpdate>, callback?: coreHttp.ServiceCallback<Models.DeviceWideUpdate>): Promise<Models.SharedDevicesUpdateDeviceResponse> {
    return this.client.sendOperationRequest(
      {
        deviceId,
        options
      },
      updateDeviceOperationSpec,
      callback) as Promise<Models.SharedDevicesUpdateDeviceResponse>;
  }
}

// Operation Specifications
const serializer = new coreHttp.Serializer(Mappers);
const updateDeviceOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "PATCH",
  path: "api/v1/devices/{deviceId}",
  urlParameters: [
    Parameters.deviceId
  ],
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.DeviceWideUpdate
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {
      bodyMapper: Mappers.DeviceWideUpdate
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};
